import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, IsBoolean, IsOptional, ValidateNested } from "class-validator";

export class MailConfiguration {
  @IsString()
  @Expose()
  login!: string;
  @IsString()
  @Expose()
  emailAddress!: string;
  @IsOptional()
  @IsString()
  @Expose()
  smtpHost!: string;
  @IsOptional()
  @IsString()
  @Expose()
  imapHost!: string;
  @IsNumber()
  @Expose()
  id!: number;
  @IsOptional()
  @IsBoolean()
  @Expose()
  imapSSL!: boolean;
  @IsOptional()
  @IsBoolean()
  @Expose()
  smtpSSL!: boolean;
  @Type(() => MailConfigurationProperty)
  @ValidateNested()
  @Expose()
  mailConfigurationProperties!: Array<MailConfigurationProperty>;
  @IsString()
  @Expose()
  password!: string;
  @IsOptional()
  @IsNumber()
  @Expose()
  imapPort!: number;
  @IsOptional()
  @IsNumber()
  @Expose()
  smtpPort!: number;

  constructor() {
    this.login = "";
    this.emailAddress = "";
    this.id = 0;
    this.password = "";
    this.imapHost = "";
    this.imapPort = 0;
    this.imapSSL = false;
    this.smtpHost = "";
    this.smtpPort = 0;
    this.smtpSSL = false;
    this.mailConfigurationProperties = [];
  }
}

export class MailConfigurationProperty {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  key!: number;
  @IsString()
  @Expose()
  label!: string;
  @IsString()
  @Expose()
  value!: string;

  constructor(key: number, label: string, value: string) {
    this.key = key;
    this.label = label;
    this.value = value;
  }
}
